import { IAgGridDropdownMenuOption } from 'v2/modules/shared/components/ag-grid-dropdown-menu-cell-renderer/ag-grid-dropdown-menu-cell-renderer.component';
import { IBaseGridConstant } from 'v2/modules/shared/interfaces/ag-grid/ag-grid.types';

import {
  EShipmentGridDropdownAction,
  EShipmentsGridField,
} from '../types/shipments-grid.types';

const filterApiParamsMapping: { [key in EShipmentsGridField]: string } = {
  [EShipmentsGridField.ID]: 'id',
  [EShipmentsGridField.SHIPMENT_ID]: 'shipmentId',
  [EShipmentsGridField.FULFILLMENT_ID]: 'fulfillmentId',
  [EShipmentsGridField.STATUS]: 'status',
  [EShipmentsGridField.SHIP_DATE]: 'shipDate',
  [EShipmentsGridField.TRACKING_NUMBER]: 'trackingNumber',
  [EShipmentsGridField.CARRIER_CODE]: 'carrierCode',
  [EShipmentsGridField.CUSTOMER_NAME]: 'customerName',
  [EShipmentsGridField.SHIPPING_ADDRESS]: 'shippingAddress',
  [EShipmentsGridField.SHIPMENT_COST]: 'shipmentCost',
};

const sortingApiParamsMapping: { [key in EShipmentsGridField]: string } = {
  ...filterApiParamsMapping,
  [EShipmentsGridField.FULFILLMENT_ID]: 'fulfillment_id',
};

const actionDropdownOptions: IAgGridDropdownMenuOption[] = [
  {
    label: 'Create Invoice From Shipment',
    icon: '',
    action: EShipmentGridDropdownAction.CREATE_INVOICE_FROM_SHIPMENT,
  },
];

const defaultRelations: string[] = [
  'invoice',
  // default relations here
];

const topLevelFilters: string[] = [
  // top level filters here
];

export const ShipmentsGridConstants: IBaseGridConstant<EShipmentsGridField> = {
  filterApiParamsMapping,
  sortingApiParamsMapping,
  actionDropdownOptions,
  defaultRelations,
  topLevelFilters,
};
